<template>
<div>
<navigation></navigation>
  <!--Main contents-->
  <div class="box_center" id="page_x" v-if="user">
    <h2 class="shadow">My Account</h2>

    <h4>Status: <span>{{user && user.premium ? 'Premium' : 'Free'}}</span></h4>
    <router-link v-if="!user || !user.premium" :to="{path: '/buy'}">Buy Picks!</router-link>
    <p><router-link :to="{path: '/changepassword'}">Change Password</router-link></p>
    <div class="email-field">
      <label class="email-label">Email:</label>
      <input type="text" name="email" class="email-input" v-model="user.email"/>
    </div>

    <div class="notifications-section">
      <h4 class="section-label">Pick Notifications</h4>
      <form name="form1">

        <div class="notify-option">
          <label class="notify-checkbox">
            <input type="checkbox" v-model="notifyEmail" />
            <span class="checkbox-label">Email</span>
          </label>
          <div v-if="notifyEmail" class="notify-config">
            <input type="text" name="contact_email_addr" placeholder="Enter Contact Email" class="notify-input" v-model="contactEmail" />
          </div>
        </div>

        <div class="notify-option">
          <label class="notify-checkbox">
            <input type="checkbox" v-model="notifyPush" />
            <span class="checkbox-label">Push Notification</span>
          </label>
          <div v-if="notifyPush" class="notify-config">
            <push-setup @subscribed="onDeviceSubscribed"></push-setup>
            <p v-if="pushSaveError" class="push-save-error">{{ pushSaveError }}</p>
          </div>
        </div>

        <div class="notify-option notify-option-legacy" v-if="user.notify_sms || user.contact_method === 2">
          <label class="notify-checkbox">
            <input type="checkbox" v-model="notifySms" />
            <span class="checkbox-label">Text Message</span>
            <span class="legacy-badge">Legacy</span>
          </label>
          <p class="legacy-notice">Text messages are no longer available for new sign-ups. Please use Push Notifications instead.</p>
          <div v-if="notifySms" class="notify-config">
            <select v-model="phone" name="phones" id="phoneList" class="carrier-select">
              <option v-for="p in phoneOpts" :value="p">{{ p.key }}</option>
            </select>
            <input type="text" name="contact_phone" placeholder="Enter Contact Phone" class="notify-input" v-model="contactPhone" />
          </div>
        </div>

        <button class="button" style="width:100%;margin-top:16px;" @click.prevent="save()">Save</button>
      </form>
    </div>
  </div>
</div>
</template>

<script>
import Nav from '../components/Nav'
import PushSetup from '../components/PushSetup'
import AuthRepository from '../data/auth.repository'
import _ from 'lodash'
export default {
  components: {
    'navigation': Nav,
    'push-setup': PushSetup
  },
  computed: {
    user () {
      return this.$store.state.currentUser
    }
  },
  data () {
    return {
      notifyEmail: false,
      notifyPush: false,
      notifySms: false,
      pushSaveError: '',
      contactEmail: '',
      contactPhone: '',
      phone: {},
      phoneOpts: [
        {key: 'Select Carrier', value: 0},
        {key: 'Verizon', value: 2},
        {key: 'T-Mobile', value: 3},
        {key: 'Sprint', value: 4},
        {key: 'U.S. Cellular', value: 5},
        {key: 'Virgin Mobile', value: 6},
        {key: 'Tracfone', value: 7},
        {key: 'Metro PCS', value: 8},
        {key: 'Boost Mobile', value: 9},
        {key: 'Cricket', value: 10},
        {key: 'Nextel', value: 11},
        {key: 'Alltel', value: 12},
        {key: 'Ptel', value: 13},
        {key: 'Suncom', value: 14},
        {key: 'Qwest', value: 15}
      ]
    }
  },
  methods: {
    // Persist notify_push as soon as a device registers so users who never
    // tap Save still receive pushes. The API only updates fields present in
    // the payload, so other preferences are untouched.
    onDeviceSubscribed () {
      this.pushSaveError = ''
      this.notifyPush = true
      var payload = {
        id: this.user.id,
        email: this.user.email,
        notify_push: 1
      }
      AuthRepository.save(payload).then(() => {
        this.$store.dispatch('getStoredUser')
      }).catch(() => {
        this.pushSaveError = 'Your device is registered, but we could not turn on push automatically. Please tap Save.'
      })
    },
    save () {
      var payload = {
        id: this.user.id,
        email: this.user.email,
        notify_email: this.notifyEmail ? 1 : 0,
        notify_push: this.notifyPush ? 1 : 0,
        notify_sms: this.notifySms ? 1 : 0,
        contact_method: this.notifySms ? 2 : (this.notifyEmail ? 1 : 0),
        contact_email: this.notifyEmail ? this.contactEmail : (this.notifySms ? this.contactPhone : ''),
        contact_phone: this.notifySms ? (this.phone.value || 0) : 0
      }
      AuthRepository.save(payload).then((result) => {
        this.$store.dispatch('getStoredUser')
        this.$router.push('/')
      }).catch(() => console.log('An error occurred'))
    }
  },
  mounted () {
    var u = this.$store.state.currentUser
    if (!u || !u.id) return this.$router.push('/login')
    if (u.notify_email !== undefined) {
      this.notifyEmail = !!u.notify_email
    } else {
      this.notifyEmail = u.contact_method === 1
    }
    if (u.notify_push !== undefined) {
      this.notifyPush = !!u.notify_push
    }
    if (u.notify_sms !== undefined) {
      this.notifySms = !!u.notify_sms
    } else {
      this.notifySms = u.contact_method === 2
    }

    if (u.contact_method === 1 && u.contact_email) {
      this.contactEmail = u.contact_email
    } else if (u.email) {
      this.contactEmail = u.email
    }
    if (u.contact_method === 2 && u.contact_email) {
      this.contactPhone = u.contact_email
    }

    if (!u.contact_phone || u.contact_phone === 0) {
      this.phone = this.phoneOpts[0]
    } else if (u.contact_phone) {
      this.phone = _.find(this.phoneOpts, ['value', u.contact_phone]) || this.phoneOpts[0]
    }
  },
  metaInfo: {
    title: 'My Account'
  }
}
</script>

<style lang="css" scoped>
.email-field {
  margin-bottom: 20px;
}

.email-label {
  font-size: 13px;
  color: #5e636d;
  display: block;
  margin-bottom: 4px;
}

.push-save-error {
  color: #e94560;
  font-size: 12px;
  margin-top: 8px;
  background: #ffe8ec;
  padding: 8px 10px;
  border-radius: 4px;
}

.email-input {
  width: 100%;
  height: 34px;
  padding: 0 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #fff;
  color: #5e636d;
  font-size: 13px;
  font-family: Arial, Verdana, Helvetica, sans-serif;
  box-sizing: border-box;
}

.notifications-section {
  margin-top: 16px;
}

.section-label {
  color: #5e636d;
  font-size: 13px;
  font-weight: bold;
  margin-bottom: 8px;
  padding-bottom: 6px;
  border-bottom: 1px solid #e0e0e3;
}

.notify-option {
  margin-bottom: 12px;
  padding: 12px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #e0e0e3;
}

.notify-option-legacy {
  background: #f9f9fb;
  border-color: #d0d0d5;
}

.notify-checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 0;
}

.notify-checkbox input[type="checkbox"] {
  margin: 0 8px 0 0;
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.checkbox-label {
  font-size: 13px;
  color: #5e636d;
  font-weight: bold;
  flex: 1;
}

.legacy-badge {
  font-size: 10px;
  color: #999;
  background: #e9e9ed;
  padding: 2px 6px;
  border-radius: 3px;
  text-transform: uppercase;
  font-weight: bold;
  letter-spacing: 0.5px;
}

.legacy-notice {
  font-size: 11px;
  color: #999;
  margin: 6px 0 0 26px;
  font-style: italic;
}

.notify-config {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #e9e9ed;
}

.notify-input {
  width: 100%;
  height: 34px;
  padding: 0 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #fff;
  color: #5e636d;
  font-size: 13px;
  font-family: Arial, Verdana, Helvetica, sans-serif;
  box-sizing: border-box;
}

.carrier-select {
  width: 100%;
  height: 34px;
  padding: 0 8px;
  margin-bottom: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #fff;
  color: #5e636d;
  font-size: 13px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// MyAccount.vue?bdaa2708